"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LazyLoadOptions = void 0;
var LazyLoadOptions;
(function (LazyLoadOptions) {
    LazyLoadOptions["NO_LAZY_LOAD"] = "noLazyLoad";
    LazyLoadOptions["LAZY_LOAD"] = "lazyLoad";
    LazyLoadOptions["LAZY_PRE_LOAD"] = "lazyPreLoad";
})(LazyLoadOptions || (exports.LazyLoadOptions = LazyLoadOptions = {}));
//# sourceMappingURL=LazyloadEnums.js.map